module.exports = __webpack_public_path__ + "static/media/appStore.51fb9288.svg";